export default "__VITE_ASSET__BWEjRI7K__"